"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationPlans = exports.getPlan = void 0;
var _recommendationSelectors = require("../../store/recommendation/recommendationSelectors");
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _react = require("react");
var _useRecommendationStatus = require("./useRecommendationStatus");
var _constants = require("../../utils/constants");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
const getSelectedPlan = () => {
  const selectedPlan = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectSelectedPlan);
  const selectedVariant = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.selectedVariant;
  return {
    ...selectedPlan,
    ...selectedVariant,
    isAlternativePlan: false
  };
};
const getPlan = tier => {
  const plan = (0, _useAppSelector.useAppSelector)(instanceId => state => (0, _recommendationSelectors.selectPlan)(state, tier, instanceId));
  if (!plan) {
    return null;
  }
  return {
    ...plan
  };
};
exports.getPlan = getPlan;
const getAlternativePlans = () => {
  const selectedPlan = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectSelectedPlan);
  const plans = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectRecommendationPlans);
  return plans.filter(plan => plan.productId !== selectedPlan.productId).map(plan => ({
    ...plan,
    ...plan.selectedVariant,
    priceGapValue: plan.selectedVariant.price.priceValue - selectedPlan.selectedVariant.price.priceValue,
    isAlternativePlan: true
  }));
};
const useRecommendationPlans = () => {
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const {
    arePlansPresent
  } = (0, _useRecommendationStatus.useRecommendationStatus)();
  if (!arePlansPresent) {
    return {};
  }
  const recommendedPlan = getPlan(_constants.RECOMMENDATION_TIER.RECOMMENDED);
  const premiumPlan = getPlan(_constants.RECOMMENDATION_TIER.PREMIUM);
  const budgetPlan = getPlan(_constants.RECOMMENDATION_TIER.BUDGET);
  const alternativePlan = getPlan(_constants.RECOMMENDATION_TIER.ALTERNATIVE);
  const alternativePremiumPlan = !premiumPlan && alternativePlan;
  const alternativeBudgetPlan = !budgetPlan && alternativePlan;
  const selectedPlan = getSelectedPlan();
  const alternativePlans = getAlternativePlans();
  const [isAlternativePlanContainerOpen, setIsAlternativePlanContainerOpen] = (0, _react.useState)(false);
  const onPlanSelect = productId => {
    setIsAlternativePlanContainerOpen(false);
    dispatch((0, _recommendationActions.updateSelectedPlan)(productId));
  };
  // sec.logCustomEvent(
  //   'recommendation',
  //   `Recommended Plan: ${selectedPlan?.productName},
  //     Premium plan: ${premiumPlan?.productName},
  //     Budget plan: ${budgetPlan?.productName},
  //     Alt Premium plan: ${alternativePremiumPlan?.productName},
  //     Alt Budget plan: ${alternativeBudgetPlan?.productName},
  //     Alternative plans: ${alternativePlans?.map(plan => {
  //       return plan?.productName;
  //     })}`,
  //   'recommendationPage',
  //   'recommendation plans',
  // );
  return {
    recommendedPlan,
    premiumPlan,
    budgetPlan,
    alternativePremiumPlan,
    alternativeBudgetPlan,
    selectedPlan,
    alternativePlans,
    isAlternativePlanContainerOpen,
    setIsAlternativePlanContainerOpen,
    onPlanSelect
  };
};
exports.useRecommendationPlans = useRecommendationPlans;